import React, { Component } from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
// import { renderRoutes } from 'react-router-config';
import { Spinner, Row, Container } from 'reactstrap';
import './App.scss';


import * as firebase from 'firebase/app';
import "firebase/auth";
import "firebase/firestore"

const firebaseConfig = {
  apiKey: "AIzaSyBjLbujbbyvXQAtSdAPVQXljPB7p4pZc7U",
  authDomain: "pj-mercado.firebaseapp.com",
  databaseURL: "https://pj-mercado.firebaseio.com",
  projectId: "pj-mercado",
  storageBucket: "pj-mercado.appspot.com",
  messagingSenderId: "1093104502506",
  appId: "1:1093104502506:web:1b3e7c55ee3910cc17b993",
  measurementId: "G-87L7Q24W86"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

const loading = () => <div className="animated fadeIn pt-3 text-center">Loading...</div>;
// Containers
const DefaultLayout = React.lazy(() => import('./containers/DefaultLayout/DefaultLayout'));
const AdmLayout = React.lazy(() => import('./containers/DefaultLayout/AdmLayout'));

// Pages
const Login = React.lazy(() => import('./views/Pages/Login/Login'));
const Register = React.lazy(() => import('./views/Pages/Register/Register'));
//const Page404 = React.lazy(() => import('./views/Pages/Page404'));
//const Page500 = React.lazy(() => import('./views/Pages/Page500'));

class App extends Component {
  constructor(props){
    super(props);
    this.state = {
      logado: null,
      adm: 0
    }
  }

  componentWillMount(){
    console.log(sessionStorage.getItem('adm'));
    firebase.auth().onAuthStateChanged((user) => {
      if (user && sessionStorage.getItem('adm') !== null){        
console.log('logado');
        sessionStorage.setItem('userId', user.uid);
        sessionStorage.setItem('userEmail', user.email);
        
        let MtLojas = [];
        let c = 0;
        let usuario = sessionStorage.getItem('userId');
        
        const result = firebase.firestore().collection('usuarios').doc(usuario).collection('lojas');
        result.get().then(s => {
            //MtLojas[0] = ({nome: 'teste 123', id: '0001'});
            s.forEach(doc => {
                firebase.firestore().collection('mercados').doc(doc.data().codigo).get()
                .then((loja) => {
                  MtLojas[c] = ({ nome: loja.data().nome, id: loja.id, logo: loja.data().logo });
                  c++;
                }).then(() => {
                  sessionStorage.setItem("lojas", JSON.stringify(MtLojas));
                  this.setState({logado: true, adm: sessionStorage.getItem('adm')});
                })
            })
        });
      }else{
        this.setState({logado: false});
      }
    })
  }
  

  render() {
    if(this.state.logado === false){
      return (
        <HashRouter>
            <React.Suspense fallback={loading()}>
              <Switch>
                <Route exact path="/register" name="Register Page" render={props => <Register {...props}/>} />
                <Route exact path="/" name="Login Page" render={props => <Login {...props}/>} />
              </Switch>
            </React.Suspense>
        </HashRouter>
      );
      }else if(this.state.logado && this.state.adm === '1' ){
        return (
          <HashRouter>
              <React.Suspense fallback={loading()}>
                <Switch>
                  <Route path="/" name="Home" render={props => <AdmLayout {...props}/>} />
                </Switch>
              </React.Suspense>
          </HashRouter>
        );  
      }else if(this.state.logado && this.state.adm === '0' ){
        return (
          <HashRouter>
              <React.Suspense fallback={loading()}>
                <Switch>
                  <Route path="/" name="Home" render={props => <DefaultLayout {...props}/>} />
                </Switch>
              </React.Suspense>
          </HashRouter>
        );  
      }else{
        return (
          <div className="app flex-row align-items-center">
            <Container>
            <Row className="justify-content-center">
              <Spinner color="dark" />
            </Row>
            </Container>
          </div>
        );  
      }
    }
}

export default App;
/*
              <Route exact path="/login" name="Login Page" render={props => <Login {...props}/>} />
              <Route exact path="/register" name="Register Page" render={props => <Register {...props}/>} />
              <Route exact path="/404" name="Page 404" render={props => <Page404 {...props}/>} />
              <Route exact path="/500" name="Page 500" render={props => <Page500 {...props}/>} />
              <Route path="/" name="Home" render={props => <DefaultLayout {...props}/>} />
*/